module.exports = __webpack_public_path__ + "static/media/11a.b490c149.jpg";